module.exports = __webpack_public_path__ + "static/media/undraw_design-tools_wgpz.4b432b34.svg";